



import axios from 'axios'
export const CHAT_SERVER_HOST = "https://chat.borderfree.app"; //https://chat.borderfree.app http://49.212.213.144:8005

const request = axios.create({
    baseURL: CHAT_SERVER_HOST,
    timeout: 30000,
    headers: {}
})

request.interceptors.request.use(function (config) {
    let token = localStorage.getItem("token") || ''
    config.headers['X-Access-Token'] = token
    return config

}, function (error) {

    return Promise.reject(error)
    
})

export default request
